import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginReg from '../LoginReg';
import { AuthContext } from '../../context/Authcontext';

/* =====================================================================
   Mobile bottom navigation
   =====================================================================
   Was three icons plus a hamburger, with the labels hidden until hover --
   a hover state on a touch device, so on a phone they were four unlabelled
   pictures. It also carried a scrolling "Welcome to our exchange" marquee
   pinned to the bottom of every desktop page.

   Five destinations now, each with a permanent label, so the drawer is
   somewhere you go occasionally rather than the only way to move around.
   ===================================================================== */

const TABS = [
  { key: 'home', label: 'Home', icon: 'fa-home', path: '/' },
  { key: 'sports', label: 'Sports', icon: 'fa-trophy', path: '/sportall' },
  { key: 'casino', label: 'Casino', icon: 'fa-dice', path: '/casinoGames' },
  { key: 'bets', label: 'Bets', icon: 'fa-receipt', path: '/sports_bets', state: { activeTab: 0 }, auth: true },
  // Opens the account menu (name, balance, Deposit / Withdraw, bets,
  // statements, logout at the top of the side drawer) rather than jumping
  // straight to Account Statement.
  { key: 'me', label: 'Me', icon: 'fa-user', menu: true, auth: true },
];

const MarqueeBottom = ({ onMenuClick }) => {
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);

  const activeKey = (() => {
    const p = location.pathname;
    if (p === '/' || p === '/home') return 'home';
    if (['/sportall', '/cricketreal', '/footballreal', '/tennisreal', '/inplay'].indexOf(p) !== -1)
      return 'sports';
    if (p === '/casinoGames') return 'casino';
    if (p === '/sports_bets') return 'bets';
    if (['/accountstatement', '/plstatement', '/deposit', '/withdraw'].indexOf(p) !== -1) return 'me';
    return '';
  })();

  const handle = (tab) => {
    // Signed-out visitors get the login sheet rather than a redirect to a
    // page that will bounce them straight back.
    if (tab.auth && !isAuthenticated) {
      setactive(true);
      return;
    }
    if (tab.menu) {
      // Press the header's menu button (both headers mark it), so Me opens
      // the same side menu everywhere. Many pages pass onMenuClick as
      // handleCanvasShow, which opens the old balance panel instead.
      const trigger = document.querySelector('[data-rb-menu-trigger]');
      if (trigger) {
        if (!document.querySelector('#sidebar')) trigger.click();
      } else if (onMenuClick) {
        onMenuClick();
      }
      return;
    }
    navigate(tab.path, tab.state ? { state: tab.state } : undefined);
  };

  return (
    <>
      <LoginReg
        active={active}
        setactive={setactive}
        regactive={regactive}
        setregactive={setregactive}
      />

      {/* Keeps the last section of the page clear of the fixed bar. */}
      <div className="rb-tabbar__spacer" aria-hidden="true" />

      <nav className="rb-tabbar" aria-label="Main">
        {TABS.map((tab) => (
          <button
            type="button"
            key={tab.key}
            className={
              activeKey === tab.key ? 'rb-tabbar__item rb-tabbar__item--active' : 'rb-tabbar__item'
            }
            aria-current={activeKey === tab.key ? 'page' : undefined}
            onClick={() => handle(tab)}
          >
            <i className={'fa ' + tab.icon} aria-hidden="true" />
            <span>{tab.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
};

export default MarqueeBottom;
